import { createFileRoute } from "@tanstack/react-router"
import { WhatsappTemplateCreate } from "modules/campaigns/components/Sections/channels/whatsapp/Editor/WhatsappCreate"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/templates/create")({
  component: WhatsappTemplateCreate,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("campaigns.templates.create.title"),
    })
  },
})
